import ProjectService from '../../project.service.js';
import Service from '@/service/index.js';
import SummaryInfo from './summary-info/summary-info.vue';
import NavList from './nav-list/nav-list.vue';
import LandInfo from './land-info/land-info.vue';
import BasicInfo from './basic-info/basic-info.vue';
import TransfereeInfo from './transferee-info/transferee-info.vue';
import AttachmentInfo from './attachment-info/attachment-info.vue';
import {transactionProjectStatus} from '@/utils/mixins/transaction-project-status.js';
import { errorMessage, successMessage } from '@/utils/message.js';
import Payment from '@/components/payment/payment.vue';
import AssetsInfo from '@/components/assets-info/assets-info.vue';
import AssigneeInfo from './assignee-info/index.vue';
export default {
  components: {
    Payment,
    SummaryInfo,
    NavList,
    LandInfo,
    BasicInfo,
    TransfereeInfo,
    AttachmentInfo,
    AssetsInfo,
    AssigneeInfo
  },
  mixins: [transactionProjectStatus],
  data() {
    return {
      id: '',
      specialStatus: '',
      projectStatusArr: [],
      projectInfo: null, // 项目信息
      transfereeInfo: null, // 受让信息
      attachmentInfo: [], // 附件信息
      commitmentInfo: null, // 承诺书信息
      userInfo: null,
      bidInfo: null,
      assigneeInfo: null, // 受让方信息
      // arr: ['项目信息', '附件信息', '成交信息', '项目文件信息'],
      arr: ['项目信息', '档案信息'],
      activeKey: '项目信息',
      showPayment: false,
      currentProjectId: '',
      unBidSelArr: [],
      bidTypeArr: [],
      fileInfo: [], // 项目文件
      fileList: [], // 字典项目文件获取title

      subjectMortgageList: [],
      subjectTitleList: []
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.specialStatus = this.$route.query.specialStatus;
    this.getProjectDetail();
    this.initImageInfo();
    // this.initFileInfo();
    this.getProjectFileInfo();
    const arr = [
      ['unBidSelArr', 'NOT_SOLICITED_CHOOSE'],
      ['bidTypeArr', 'BIDDING_METHOD'],
      ['subjectMortgageList', 'SUBJECT_MORTGAGE'],
      ['subjectTitleList', 'SUBJECT_TITLE_CERTIFICATE_SITUATION']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
  },
  computed: {
    noticeEndTimeHoursAdd1 () {
      const str = this.projectInfo && this.projectInfo.noticeEndTime;
      if (str) {
        const timeStr = new String(str).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
        return this.formatDate(new Date(new Date(timeStr).getTime() + 3600000 + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    unBidSelText () {
      const str = this.transfereeInfo && this.transfereeInfo.unBidSel;
      const item = this.unBidSelArr && this.unBidSelArr.find(item => item.code === String(str));
      if (str === 2) {
        return item && (item.value + '，' + item.description) || '';
      }
      return item && item.value || '';
    },
    getProjectImg () {
      if (this.attachmentInfo) {
        const obj = this.attachmentInfo.find(item => item.projectFileType === 1);
        return obj && obj.filePaths || [];
      } else {
        return [];
      }
    },
    projectCode() {
      if(this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    }
  },
  mounted() {
    this.getPurchaseFileList();
  },
  methods: {
    getProjectDetail () {
      const obj = {
        ASSIGNMENT: 'transfereeInfo',
        PROMISE: 'commitmentInfo',
        // USER: 'userInfo',
        BID: 'bidInfo',
        ASSIGNEE: 'assigneeInfo'
      };
      Object.keys(obj).forEach(key => {
        ProjectService.getRollOutProjectDetail({
          projectId: this.id,
          echoCode: key
        }).then(res => {
          this[obj[key]] = res && res.data;
        });
      });
      ProjectService.getBatchProject(this.id).then(res => {
        this.projectInfo = res.data;
      });

    },
    getPurchaseFileType (type) {
      return new Promise((resolve, reject) => {
        Service.getSelectList(type).then(res => {
          if (res && res.code === '0') {
            resolve(res.data);
          }
          reject();
        }, () => {
          reject();
        });
      });
    },
    getAttachmentInfo () {
      return new Promise((resolve, reject) => {
        ProjectService.getRollOutProjectDetail({
          projectId: this.id,
          echoCode: 'FILE'
        }).then(res => {
          if (res && res.code === '0' && res.data && res.data.files) {
            resolve(res.data.files);
          }
          reject();
        }, () => {
          reject();
        });
      });
    },
    initImageInfo () {
      Promise.all([this.getPurchaseFileType('PROJECT_FILE_TYPE'), this.getAttachmentInfo()]).then(res => {
        const arr = JSON.parse(JSON.stringify(res[0])).sort((a, b) => a.sort - b.sort);
        // 初始化附件信息
        const arr1 = arr;
        // const arr1 = arr.slice(0, 9);
        arr1.forEach(item => {
          let obj = res[1].find(file => file.projectFileType === Number(item.code));
          this.attachmentInfo.push({
            projectFileType: Number(item.code),
            title: item.value,
            filePaths: obj && (obj.filePaths.map(item => item.allPath)) || []
          });
        });
      });
    },
    getProjectFileInfo () {
      ProjectService.getProjectFileList(this.id).then(res => {
        if (res && res.code === '0' && res.data) {
          res.data.forEach(file => {
            this.fileInfo.push({
              projectFileType: Number('0' + file.type),
              title: file.contractName,
              filePaths: [{
                url: file.url,
                name: file.userName
              }]
            });
            // console.log(this.fileInfo, '1');
          });
        }
      });
    },
    getPurchaseFileList () {
      this.getPurchaseFileType('TRANSFER_CONTRACT_TYPE').then(res => {
        this.fileList = res;
      });
    },
    // initFileInfo () {
    //   Promise.all([this.getPurchaseFileType('TRANSFER_CONTRACT_TYPE'), this.getProjectFileInfo()]).then(res => {
    //     // 初始化附件信息
    //     res[1].forEach(file => {
    //       let obj = res[0].find(item => item.code === String(file.type));
    //       const index = this.fileInfo.findIndex(item => item.projectFileType === file.type);
    //       if (index !== -1) {
    //         this.fileInfo[index].filePaths.push({
    //           url: file.url,
    //           userName: file.userName
    //         });
    //       } else {
    //         this.fileInfo.push({
    //           projectFileType: Number(file.type),
    //           title: obj && obj.value,
    //           filePaths: [{
    //             url: file.url,
    //             userName: file.userName
    //           }]
    //         });
    //       }
    //     });
    //   });
    // },
    changeActiveIndex (key) {
      this.activeKey = key;
    },
    confirmProjectById (id) {
      this.$confirm('确定要确认公告？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ProjectService.confirmProjectById(id).then(res => {
          if (res && res.code === '0') {
            successMessage('确认公告成功');
            this.$router.push('/person-center/project/roll-out-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('确认公告失败');
          }
        }, (error) => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          } else {
            errorMessage('确认公告失败');
          }
        });
      }).catch();
    },
    paymentSuccess () {
      this.getProjectDetail();
    },
    formatDate(date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    },
    openWindow (url) {
      window.open(url);
    },
    dispose () {
      this.$router.push('/person-center/project/roll-out-project/trans?id=' + this.id);
    }
  }
};
